import React, { Component } from 'react';
import { Spring, animated, config } from 'react-spring';
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';

import { startAnimation, endAnimation } from 'js/config/style';
import Modal from 'js/components/core/Modal';

import Container from './Container';
import Number from './Number';
import Button from './Button';
import Row from './Row';
import Title from './Title';
import Instruction from './Instruction';
import EstimatedPickup from './EstimatedPickup';

import Places from './DropoffLocations/Places';
import Place from './DropoffLocations/Place';
import DetailsLink from './DropoffLocations/DetailsLink';
import ModalContents from './DropoffLocations/ModalContents';
import NameAndAddress from './DropoffLocations/NameAndAddress';
import HoursOfOperation from './DropoffLocations/HoursOfOperation';
import EmbeddedMap from './DropoffLocations/EmbeddedMap';
import analytics from "js/services/Analytics";
import {url} from "js/services/Network";
import userCountry from 'js/services/UserCountry';

@inject('page')
@observer
export default class ShippingInstructions extends Component {
  @observable locationIndex = null;
  @observable modalIsVisible = false;
  @observable landing = () => {console.log("instructions = ", this.props.page.shipment_instructions)}

  @action showModal = locationIndex => {
    this.locationIndex = locationIndex;
    this.modalIsVisible = true;
  };

  @action closeModal = () => (this.modalIsVisible = false);

  @action onPrintLabelButtonClick = (link) => {

    const page = this.props.page;

    window.open(link, '_blank');

    analytics.track('Purchase Accepted', {
      'Shipping Option': page.order_shipping,
      'Item Price': page.price,
      'Item Name': page.title,
      'Item Size': '',
      'Payment Link':  url('checkout-page', { alias: page.alias }),
      'Event Initiated by': 'buyer'
    });
  };


  render() {

    const {
      label_url,
      item_title,
      shipper_will_pickup,
      shipper,
      estimated_pickup,
      dropoff_locations,
    } = this.props.page.shipment_instructions;
    console.log("shipper: ", shipper)



    return (
      <>
        <Spring native from={startAnimation} to={endAnimation} config={config.gentle}>
          {animation => (
            <animated.div style={animation}>
              <Container>
                {shipper === 'Fez' ? (
                  <>
                    {/*<Row>*/}

                    {/*  <Number>1</Number>*/}
                    {/*  <div>*/}
                    {/*    <Button onClick={() => this.onPrintLabelButtonClick(label_url)} icon="print" >*/}
                    {/*      {userCountry() !== 'NG' ? 'Print Your Shipping Label' : 'Get your QR code'}*/}
                    {/*    </Button>*/}
                    {/*  </div>*/}
                    {/*</Row>*/}

                    <Row>
                      <Number>1</Number>
                      <Title>Put your stuff in a box</Title>
                      <Instruction>Put your {item_title} in a box or some other kind of packaging to ship.</Instruction>
                    </Row>

                    <Row>
                      <Number>2</Number>
                      <Title>
                        {userCountry() === 'NG' ? 'Wait for your driver for pickup' : 'Clearly label the box'}
                      </Title>
                      {userCountry() !== 'NG' && (
                        <Instruction>Make sure every part of the label is readable so it ships easily!</Instruction>
                      )}
                    </Row>

                    {userCountry() !== 'NG' && (
                      <Row>
                        <Number>3</Number>
                        {shipper_will_pickup ? (
                          <>
                            <Title>Pickup</Title>
                            <Instruction>
                              <div>We are sending someone from {shipper}.</div>
                              <EstimatedPickup>{estimated_pickup}</EstimatedPickup>
                            </Instruction>
                          </>
                        ) : (
                          <>
                            <Title>Dropoff your item</Title>
                            <Instruction>
                              Ship this order at your nearest {shipper} location.
                              <Places>
                                {dropoff_locations.map((location, index) => (
                                  <Place key={index} onClick={() => this.showModal(index)}>
                                    <NameAndAddress location={location} />
                                    <DetailsLink>View details &amp; map</DetailsLink>
                                  </Place>
                                ))}
                              </Places>
                            </Instruction>
                          </>
                        )}
                      </Row>
                    )}
                  </>
                ) : (
                  <>
                    <Row>

                      <Number>1</Number>
                      <div>
                        <Button onClick={() => this.onPrintLabelButtonClick(label_url)} icon="print" >
                          {userCountry() !== 'NG' ? 'Print Your Shipping Label' : 'Get your QR code'}
                        </Button>
                      </div>
                    </Row>

                    <Row>
                      <Number>2</Number>
                      <Title>Put your stuff in a box</Title>
                      <Instruction>Put your {item_title} in a box or some other kind of packaging to ship.</Instruction>
                    </Row>

                    <Row>
                      <Number>3</Number>
                      <Title>
                        {userCountry() === 'NG' ? 'Wait for your driver for pickup' : 'Clearly label the box'}
                      </Title>
                      {userCountry() !== 'NG' && (
                        <Instruction>Make sure every part of the label is readable so it ships easily!</Instruction>
                      )}
                    </Row>

                    {userCountry() !== 'NG' && (
                      <Row>
                        <Number>4</Number>
                        {shipper_will_pickup ? (
                          <>
                            <Title>Pickup</Title>
                            <Instruction>
                              <div>We are sending someone from {shipper}.</div>
                              <EstimatedPickup>{estimated_pickup}</EstimatedPickup>
                            </Instruction>
                          </>
                        ) : (
                          <>
                            <Title>Dropoff your item</Title>
                            <Instruction>
                              Ship this order at your nearest {shipper} location.
                              <Places>
                                {dropoff_locations.map((location, index) => (
                                  <Place key={index} onClick={() => this.showModal(index)}>
                                    <NameAndAddress location={location} />
                                    <DetailsLink>View details &amp; map</DetailsLink>
                                  </Place>
                                ))}
                              </Places>
                            </Instruction>
                          </>
                        )}
                      </Row>
                    )}
                  </>
                )}

              </Container>
            </animated.div>
          )}
        </Spring>

        {dropoff_locations && (
          <Modal showModal={this.modalIsVisible} onCancel={this.closeModal} withCloseButton>
            <ModalContents>
              <NameAndAddress location={dropoff_locations[this.locationIndex]} includePhone />
              <HoursOfOperation location={dropoff_locations[this.locationIndex]} />
              <EmbeddedMap location={dropoff_locations[this.locationIndex]} />
            </ModalContents>
          </Modal>
        )}
      </>
    );
  }
}
